import { EntityInitializationTracker } from "src/shared/data-loading/shared/utils/EntityInitializationTracker";
export const campaignInitTracker = new EntityInitializationTracker();
